import * as React from 'react';
import { cn } from '@/lib/utils';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'dls-flex dls-h-9 dls-w-full dls-rounded-md dls-border dls-border-input dls-bg-background dls-px-3 dls-py-1 dls-text-sm dls-shadow-10 dls-transition-colors hover:dls-bg-neutral-contrast file:dls-border-0 file:dls-bg-transparent file:dls-text-sm file:dls-font-medium placeholder:dls-text-muted-foreground focus-visible:dls-outline-none focus-visible:dls-ring-2 focus-visible:dls-ring-neutral focus-visible:dls-ring-offset-2 disabled:dls-cursor-not-allowed disabled:dls-opacity-50 disabled:dls-bg-neutral-quarternary',
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = 'Input';

export { Input };
